export const formatPrice = (amount, lang = 'ur') => {
  const formattedNumber = Number(amount || 0).toLocaleString();
  if (lang === 'ur') {
    return `${formattedNumber} روپے`;
  }
  return `Rs. ${formattedNumber}`;
};

export const formatDate = (dateString) => {
  if (!dateString) return '';
  return dateString;
};

export const formatMizajDisplay = (product, mizajList, lang = 'ur') => {
  if (!product) return '';
  const groupObj = (mizajList || []).find(m => m.id === product.mizaj);
  const groupName = lang === 'ur' 
    ? (groupObj?.nameUrdu || '') 
    : (groupObj?.nameEn || '');

  const gradeName = lang === 'ur' 
    ? (product.mizajUrdu || '') 
    : (product.mizajEn || product.mizajUrdu || '');

  const comma = lang === 'ur' ? '، ' : ', ';

  if (groupName && gradeName) {
    if (groupName.trim().toLowerCase() === gradeName.trim().toLowerCase()) {
      return groupName;
    }
    return `${groupName}${comma}${gradeName}`;
  }

  return groupName || gradeName || '';
};
